// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2_Bgm","select":"Header_select__24QNV","clinic":"Header_clinic__3OTAR"};